import { HubConnectionState } from "@microsoft/signalr";
import { Observable } from "rxjs";
import RealTimeConnection from "./real-time-connection";
import { RealTimeConnectionDeps } from "./real-time-connection.deps";
import { MainHubRoute } from "./real-time-connection.constants";
import { disposeStreamSubscription, markStreamSubscriptionClosed, RealTimeStreamSubscriber } from "./real-time-stream-subscriber";

export default class RealTimeStreamConnection extends RealTimeConnection {
    constructor(
        realTimeConnectionDeps: RealTimeConnectionDeps,
        public subscriber: RealTimeStreamSubscriber
    ) {
        super(realTimeConnectionDeps, `${MainHubRoute}/${subscriber.hubInfo.hubName}`);
        this.onConnected.subscribe(isConnected => {
            if (isConnected) {
                this._stream();
            } else {
                // Only the subscription ends here. Calling dispose() would also stop the hub
                // connection, and on `onreconnecting` that would cancel the automatic reconnect
                // whose whole job is to bring this stream back.
                markStreamSubscriptionClosed(this.subscriber);
            }
        });
    }

    public dispose(): Observable<void> {
        disposeStreamSubscription(this.subscriber);
        return super.disconnect();
    }

    private _stream() {
        if (this.connection.state !== HubConnectionState.Connected) return;

        const subscriberOnComplete = this.subscriber.streamSubscriber.complete;
        this.subscriber.streamSubscriber.complete = () => {
            subscriberOnComplete();
            this.dispose();
        }
        this.stream(this.subscriber);
    }
}
